<mat-sidenav-container [hasBackdrop]="false">
  <!-- Participants drawer/sidenav -->
  <mat-sidenav
    #drawer
    mode="over"
    position="end"
    id="drawer"
    [fixedInViewport]="true"
  >
    <div id="drawer-container" class="flex flex-col">
      <div class="flex justify-between items-center ph">
        <h3 class="header mat-h3">Call participants</h3>
        <button
          id="close"
          mat-icon-button
          aria-label="close"
          (click)="drawer.toggle()"
          class="mat-blue"
        >
          <mat-icon>arrow_back</mat-icon>
        </button>
      </div>

      <mat-divider />

      <div id="participants-container">
        @if (!isCallEnded && conversationParticipants?.length) {
          <app-basic-user-selection-list
            [users]="conversationParticipants"
            [hoverDisabled]="true"
            [rippleDisabled]="true"
            leftContentMargin="20px"
          ></app-basic-user-selection-list>
        } @else {
          <div class="participants-empty">
            @if (isCallEnded) {
              Call Ended
            } @else {
              <app-basic-spinner></app-basic-spinner>
            }
          </div>
        }
      </div>
    </div>
  </mat-sidenav>

  <!-- Main content-->
  <mat-sidenav-content>
    <div class="call-container">
      <!-- Header -->
      <div #callHeader class="call-header">
        <!-- Conversation icon and name -->
        <div class="title-container">
          <app-voip-conversation-avatar
            [conversation]="conversation"
            [size]="36"
          ></app-voip-conversation-avatar>
          @if (conversationName) {
            <div class="title">
              {{ conversationName }}
            </div>
          }
        </div>

        <!-- Participants drawer button -->
        <button
          mat-icon-button
          aria-label="Info"
          (click)="drawer.toggle()"
          class="mat-white participant-button"
        >
          <mat-icon>info_outline</mat-icon>
        </button>
      </div>

      <!-- Video -->
      <div #videoContainer class="video-container">
        <!-- Other participants video -->
        <canvas
          #canvas
          id="participant-videos-canvas"
          [ngStyle]="{
            width: dimensions.width + 'px',
            height: dimensions.height + 'px',
          }"
          [hidden]="!participants.length || isCallEnded"
        ></canvas>

        <!-- Current user video and avatar -->
        <div
          #currentUserVideoCanvasContainer
          class="current-user-video-canvas-container"
          (mousedown)="handleCurrentUserVideoMouseDown($event)"
          [ngStyle]="{
            right: currentUserVideoPositions.right + 'px',
            bottom: currentUserVideoPositions.bottom + 'px',
          }"
          [hidden]="!currentUserAvatar || isCallEnded"
        >
          <canvas
            #currentUserVideoCanvas
            class="current-user-video-canvas"
            [width]="currentUserVideoCanvasContainer.clientWidth"
            [height]="currentUserVideoCanvasContainer.clientHeight"
          ></canvas>

          @if (currentUserAvatar?.isMuted) {
            <mat-icon class="mat-white microphone"> mic_off </mat-icon>
          }

          @if (currentUserAvatar) {
            <app-voip-avatar
              [ngStyle]="{
                width: '100%',
                height: '100%',
                left: currentUserAvatar.xPos + 'px',
                top: currentUserAvatar.yPos + 'px',
              }"
              [userId]="currentUserAvatar.userId"
              [name]="currentUserAvatar.name"
              [isVideoOn]="currentUserAvatar.isVideoOn"
              [isMuted]="currentUserAvatar.isMuted"
              [isLastActiveSpeaker]="
                currentUserAvatar.zoomUserId === lastActiveSpeakerUserId
              "
              [isYou]="currentUserAvatar.isYou"
              [isWorkspaceVerified]="currentUserAvatar.isWorkspaceVerified"
              [isIdentityVerified]="currentUserAvatar.isIdentityVerified"
              [isProfessionVerified]="currentUserAvatar.isProfessionVerified"
              [disableDetails]="true"
            />
          }
        </div>

        <!-- Other participant avatars -->
        @if (participants.length) {
          @for (avatar of avatars; track avatar) {
            <app-voip-avatar
              [ngStyle]="{
                width: avatar.width + 'px',
                height: avatar.height + 'px',
                left: avatar.xPos + 'px',
                top: avatar.yPos + 'px',
              }"
              [userId]="avatar.userId"
              [name]="avatar.name"
              [isVideoOn]="avatar.isVideoOn"
              [isMuted]="avatar.isMuted"
              [isLastActiveSpeaker]="
                avatar.zoomUserId === lastActiveSpeakerUserId
              "
              [isYou]="avatar.isYou"
              [isWorkspaceVerified]="avatar.isWorkspaceVerified"
              [isIdentityVerified]="avatar.isIdentityVerified"
              [isProfessionVerified]="avatar.isProfessionVerified"
            />
          }
        }
      </div>

      <!-- Footer -->
      @if (!isCallEnded) {
        <div
          class="call-footer"
          [ngClass]="{
            paged: showLeftPaginationButton || showRightPaginationButton,
          }"
        >
          <div class="pagination-container">
            @if (showLeftPaginationButton) {
              <button
                mat-button
                class="button previous"
                (click)="navigateLeft()"
              >
                Previous
              </button>
            }
            <div class="mat-white pagination-text">{{ paginationText }}</div>
            @if (showRightPaginationButton) {
              <button mat-button class="button next" (click)="navigateRight()">
                Next
              </button>
            }
          </div>
          @if (!isCallEnded) {
            <app-voip-buttons
              (notifyCallPage)="endCall(true)"
              [participantId]="participantId"
              [callId]="callId"
              [isAudioStarted]="isAudioStarted"
              [isVideoStarted]="isVideoStarted"
            />
          }
        </div>
      }

      <!-- Overlay, shown before any video streams have loaded -->
      @if (showVoipOverlay) {
        <app-voip-overlay
          [conversation]="conversation"
          [isCallEnded]="isCallEnded"
          [isNewCall]="isNewCall"
          [disableMessage]="
            hasOtherParticipantJoinedPreviously && !participants.length
          "
          [disableBackground]="
            hasOtherParticipantJoinedPreviously && !participants.length
          "
        />
      }
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
